// extracted by css-extract-rspack-plugin
export default {"ezaRestrictions":"OPdBUOq9tmksANQX"};